<div class="flex gap-2 items-center">
  {{ params.value }}
  @if (params.data?.isp_detected_at) {
    <mat-icon>info</mat-icon>
  }
</div>
